<div class="d-inline-flex">
  <ncp-button
    #addNonDrugAllergyButton
    [options]="btnNDAOptions()"
  >
    @if (!btnNDAOptions().isLoading) {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.zoonoses.animal_snake.src"
        width="18"
        height="18"
        alt="Add Non-Drug Allergy"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-button
    class="ms-2"
    #addDrugAllergyButton
    [options]="btnDAOptions()"
  >
    @if (!btnDAOptions().isLoading) {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.symbols.poison.src"
        width="18"
        height="18"
        alt="Add Drug Allergy"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="allergies_form"
      name="allergies_form"
      [formGroup]="form"
      #aFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #allergyDesc [(options)]="allergyDescDDOptions" />
      <ncp-dropdown #agentDesc [itemTemplate]="allergenTemplate" [(options)]="agentDescDDOptions" />
      <ncp-dropdown #reactionDesc [(options)]="reactionDescDDOptions" />
      <ncp-dropdown #severityDesc [(options)]="severityDescDDOptions" />
      <ncp-date #onSetDate [(options)]="onSetDateOptions" />
      <ng-template #allergenTemplate let-value>
        <div class="d-flex flex-column">
          <div class="d-inline-flex">
            <span class="col-4 atc">{{ value.c1}}</span>
            <span class="col-8 atc">{{ value.d1 }}</span>
          </div>
          <div class="d-inline-flex">
            <span class="col-4 atc">{{ value.c3}}</span>
            <span class="col-8 atc">{{ value.d3 }}</span>
          </div>
          <div class="d-inline-flex">
            <span class="col-4 atc">{{ value.c4}}</span>
            <span class="col-8 atc">{{ value.d4 }}</span>
          </div>
          <div class="d-inline-flex">
            <span class="col-4 atc">{{ value.c5}}</span>
            <span class="col-8 atc">{{ value.d5 }}</span>
          </div>
          <div class="d-inline-flex">
            <span class="col-4 atc">{{ value.code}}</span>
            <span class="col-8 atc">{{ value.description }}</span>
          </div>
        </div>
      </ng-template>
    </form>
  </ncp-modal>
</div>
